<template>
  <div class="cascader-cmp">
    <jw-cascader :popup-container="`.system-form-item-${modulesItem?.setting?.id}`" :trigger-props="{ updateAtScroll: true }" :options="setDisabledOPtion(isQuoteField ? modulesItem?.setting?.business?.fieldExt : modulesItem?.setting?.fieldExt)" :placeholder="isQuoteField ? quoteFieldPlaceholder : modulesItem?.placeholder || ''" :class="['system-form-item-fields', isQuoteField ? 'ly-form-item-fields-disabled' : '']" v-model="modulesItem.fieldValue" :disabled="isQuoteField || modulesItem.businessData == '0' || disabledAll" @change="handleChange" path-mode allow-clear allow-search />
  </div>
</template>

<script setup>
import { ref, inject } from 'vue';
import { tools } from '@/utils/tools';
const emits = defineEmits(['cb']);
const isQuoteField = inject('fhFormFieldsParams')?.isQuoteField;
const quoteFieldPlaceholder = inject('fhFormFieldsParams')?.quoteFieldPlaceholder;

const props = defineProps({
  modules: {
    type: Object,
    default: () => {}
  },
  disabledAll: {
    type: Boolean,
    default: false
  }
});

const modulesItem = ref(props?.modules);

// 级联处理选项
const setDisabledOPtion = (options) => {
  const getOptions = options && tools.isJSON(options) ? JSON.parse(options) : options ?? [];
  getOptions?.forEach((option) => {
    const isEnabled = option.isEnabled;
    option['disabled'] = !isEnabled;
    if (option.children) {
      setDisabledOPtion(option.children);
    }
  });
  return getOptions;
};
const handleChange = () => {
  emits('cb', modulesItem.value);
};
</script>

<style scoped lang="less">
@import './cascader.less';
</style>
